import { Environment } from '@cobliteam/react-environments';
import { mutationOptions } from '@tanstack/react-query';
import { requestHttp } from '../client/http';

/** Tipos de alerta que o blueprint-api cria a partir de um template de gancho (`HookTemplateRegistry`). */
export type HookAlertType = 'CHECKLIST_NON_COMPLIANCE';

/** O que o gancho pode trocar no template antes de criar a Regra de Alerta. */
export type HookAlertOverrides = {
  name?: string;
  conditionParams?: Record<string, unknown>;
  daysOfWeek?: string[];
  startTime?: string;
  endTime?: string;
  triggerTimeWindows?: unknown[];
};

export type CreateHookAlertInput = {
  alertType: HookAlertType;
  overrides?: HookAlertOverrides;
  /** Vai no `X-Client-Renderer-Version`, que o blueprint-api usa para escolher o template. */
  rendererVersion: string;
};

const blueprintHost = () => Environment.getInstance().getEnvironment().blueprintApiHost;

const toWireOverrides = ({ name, conditionParams, daysOfWeek, startTime, endTime, triggerTimeWindows }: HookAlertOverrides) => ({
  ...(name !== undefined && { name }),
  ...(conditionParams !== undefined && { condition_params: conditionParams }),
  ...(daysOfWeek !== undefined && { days_of_week: daysOfWeek }),
  ...(startTime !== undefined && { start_time: startTime }),
  ...(endTime !== undefined && { end_time: endTime }),
  ...(triggerTimeWindows !== undefined && { trigger_time_windows: triggerTimeWindows }),
});

export const blueprintAlertMutations = {
  /** Cria a Regra de Alerta do gancho pelo `/mutations` do blueprint-api, como o `MutationAction` do renderer. */
  createHookAlert: () =>
    mutationOptions({
      mutationKey: ['blueprintAlerts', 'createHookAlert'] as const,
      mutationFn: ({ alertType, overrides, rendererVersion }: CreateHookAlertInput) =>
        requestHttp({
          method: 'POST',
          host: blueprintHost(),
          path: '/mutations',
          body: { mutation: 'CreateHookAlert', payload: { alert_type: alertType, ...(overrides && { overrides: toWireOverrides(overrides) }) } },
          headers: { 'X-Client-Renderer-Version': rendererVersion },
          credentials: 'include',
        }),
    }),
};
